import Vue from 'vue';
import App from './App.vue';
import router from './router';

import VueLazyload from 'vue-lazyload';
import vueSwiper from 'vue-awesome-swiper';
/* 样式的话，我这里有用到分页器，就在全局中引入了样式 */
Vue.use(vueSwiper);
import 'swiper/dist/css/swiper.css';
Vue.use(VueLazyload);

// or with options
Vue.use(VueLazyload, {
    preLoad: 1.3,
    error: '',
    loading: './assets/loading.gif',
    attempt: 1,
    listenEvents: ['scroll']
});

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);

import global from '@/common/global.js';
import { GlobalFun } from '@/common/utils';

Vue.config.productionTip = false;
Vue.prototype.global = global;

router.beforeEach(async (to, from, next) => {
    next();
    //const userinfo = await GlobalFun.getCookie('UserInfo');
    // if (!userinfo && to.path !== '/login') {
    //     next('/login');
    // } else {
    //     next();
    // }
});

export const vm = new Vue({
    router,
    render: h => h(App)
}).$mount('#app');
